/** Block Map JS */

document.addEventListener('DOMContentLoaded', () => {

    const maps = document.querySelectorAll('[data-block-map]');
    if (!maps.length || typeof maplibregl === 'undefined') return;

    maps.forEach((mapEl) => {

        const lat = parseFloat(mapEl.dataset.lat);
        const lng = parseFloat(mapEl.dataset.lng);

        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

        const center = [lng, lat];

        const map = new maplibregl.Map({
            container: mapEl,
            style: 'https://tiles.openfreemap.org/styles/positron',
            center,
            zoom: 15,
            minZoom: 3
        });

        map.addControl(new maplibregl.NavigationControl(), 'top-right');

        new maplibregl.Marker({ color: '#1F3854' })
            .setLngLat(center)
            .addTo(map);
    });
});
